module.exports = __webpack_public_path__ + "static/media/mailchimp-templates.534f89c3.png";